// Microcopy unificado. Mensagens de erro seguem fórmula fixa: causa + ação.
// "Erro ao salvar" sozinho deixa o usuário sem saída — vira "Não foi possível
// salvar — tente de novo em instantes" (causa explícita + ação clara).
//
// Voz: você (nunca "senhor" nem 3ª pessoa). Verbo imperativo curto. Caloroso
// sem infantilizar. Botões sem ponto final, frases de apoio com ponto.
//
// Glossário aplicado: Pedido (não Compra/Order), Agendamento (não Reserva),
// Loja (não Estabelecimento), Entrega/Retirada (não Delivery/Pickup).

/**
 * Título de toast de erro. Recebe o verbo da ação que falhou e devolve uma
 * frase no padrão "Não foi possível {verb}". Sem ponto final (é título).
 *
 * @example errorTitle("salvar")    → "Não foi possível salvar"
 * @example errorTitle("agendar")   → "Não foi possível agendar"
 * @example errorTitle("excluir")   → "Não foi possível excluir"
 */
export function errorTitle(verb: string): string {
  return `Não foi possível ${verb}`;
}

/**
 * Descrição padrão pra erros sem causa específica conhecida do servidor.
 * Usar quando o catch não tem mensagem útil pra mostrar. NÃO usar quando há
 * extractApiErrorMessage com mensagem do backend — essa já é a descrição.
 */
export const TRY_AGAIN_DESCRIPTION = "Tente de novo em instantes. Se continuar, verifique sua conexão.";

/**
 * Fallback do extractApiErrorMessage quando o servidor não devolveu mensagem.
 * Mais útil que "Algo deu errado" — orienta o que fazer.
 */
export const GENERIC_ERROR_FALLBACK = "Não foi possível concluir — tente de novo em instantes.";

// Aviso ao cliente quando a loja edita um pedido do LINK (07/09/2026). Abre
// como as mensagens de status: o lojista vê o texto e decide se envia.
// Variáveis: {cliente_nome} {numero_pedido} {itens} {total} {loja_nome}.
export const EDITED_ORDER_MESSAGE_DEFAULT =
  "Olá {cliente_nome}! Seu pedido #{numero_pedido} foi alterado:\n\n{itens}\n\nTotal: {total}\n\nQualquer dúvida, é só chamar.";
